import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

VueRouter

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [
  {
    path: '/',
    name: 'home',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/HomeView.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('@/views/AboutView.vue'),
        meta: { title: '联系方式' }
      },
      {
        path: 'introduce',
        name: 'Introduce',
        redirect: 'introduce/product',
        component: () => import('@/views/IntroduceView/IndexView.vue'),
        children: [
          {
            path: 'product',
            name: 'Product',
            component: () => import('@/views/IntroduceView/ProductView.vue'),
            meta: { title: '产品介绍' }
          },
          {
            path: 'functionIntroduction',
            name: 'FunctionIntroduction',
            component: () => import('@/views/IntroduceView/FunctionIntroductionView.vue'),
            meta: { title: '功能介绍' }
          },
          {
            path: 'functionUsage',
            name: 'FunctionUsage',
            component: () => import('@/views/IntroduceView/FunctionUsageView.vue'),
            meta: { title: '功能使用' }
          },
          {
            path: 'advantage',
            name: 'Advantage',
            component: () => import('@/views/IntroduceView/AdvantageView.vue'),
            meta: { title: '竞争优势' }
          }
        ]
      }
    ]
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
